module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7f7b00a9"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./~/_vue-awesome-swiper@2.6.7@vue-awesome-swiper/src/swiper.vue
// module id = 148
// module chunks = 19